import api from './api';
import { Periode, CreatePeriodeRequest, UpdatePeriodeRequest } from '../types';

export const periodeService = {
  getAll: async (): Promise<Periode[]> => {
    const response = await api.get('/perioden');
    return response.data;
  },

  getById: async (id: number): Promise<Periode> => {
    const response = await api.get(`/perioden/${id}`);
    return response.data;
  },

  create: async (data: CreatePeriodeRequest): Promise<Periode> => {
    const response = await api.post('/perioden', data);
    return response.data;
  },

  update: async (id: number, data: UpdatePeriodeRequest): Promise<Periode> => {
    const response = await api.put(`/perioden/${id}`, data);
    return response.data;
  },

  // Schlägt fehl (400), wenn die Periode noch an Vertragspositionen hängt oder fest eingebaut ist.
  delete: async (id: number): Promise<void> => {
    await api.delete(`/perioden/${id}`);
  },
};

export default periodeService;
